import React from 'react'

const EditIconBase = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 21.9999V17.9999H20V21.9999H0ZM2 15.9999V12.2499L11.05 3.19994L14.8 6.94994L5.75 15.9999H2ZM15.925 5.84994L12.175 2.09994L13.975 0.299936C14.1583 0.099936 14.3917 0.00393615 14.675 0.0119361C14.9583 0.0206028 15.1917 0.116603 15.375 0.299936L17.725 2.64994C17.9083 2.83327 18 3.0626 18 3.33794C18 3.6126 17.9083 3.84994 17.725 4.04994L15.925 5.84994Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default EditIconBase
